import axios from 'axios'
import template from './dashboard-template.html'

const $ = kendo.jQuery

async function getDashboard(dashboardId, asOfDate, sectorId) {
  const {data} = await axios.get('/api/report/Dashboard', {
    params: {
      dashboardId: dashboardId,
      asOfDate: asOfDate,
      sectorId: sectorId,
    },
  })

  return data
}

function emitEvent(eventArgs) {
  parent.postMessage(eventArgs, location.protocol + '//' + location.host)
}

function loadModules(components) {
  return new Promise(function(resolve) {
    let unorderedIndex = 0
    Promise.all(
      components.map(function(component, index) {
        return new Promise(function(resolveModule) {
          if (component.module) {
            const file = component.module.replace('.js', '')
            import('../../dashboard-components/' + file + '.js').then(function(module) {
              emitEvent({
                name: 'loading',
                message: 'Loading reporting modules',
                progress: Math.floor((unorderedIndex++ / components.length) * 100),
              })

              resolveModule({
                component: component,
                index: index,
                module: module,
              })
            })
          } else {
            resolveModule({
              index: index,
              module: null,
            })
          }
        })
      }),
    ).then(function(modules) {
      const orderedModules = modules
        .filter(function(x) {
          return x.module != null
        })
        .sort(function(a, b) {
          if (a.index > b.index) {
            return 1
          } else if (a.index < b.index) {
            return -1
          }
          return 0
        })

      resolve(orderedModules)
    })
  })
}

function isChart(component) {
  return /chart/i.test(component.module)
}

function shouldSetSideBySide(index, components) {
  var el = getComponentByIndex(index, components)
  return el && isChart(el.component) && !el.component.fitInOnePage
}

function getComponentByIndex(index, components) {
  return components.filter(function(el) {
    return el.index == index
  })[0]
}

function renderComponents($printArea, asOfDate, components, clientId) {
  return new Promise(function(resolve, reject) {
    loadModules(components).then(function(modules) {
      let sectorName = null
      let unorderedIndex = 0
      Promise.all(
        modules.map(item => {
          return new Promise(resolveModule => {
            var module = item.module,
              component = item.component,
              setSideBySide = shouldSetSideBySide(item.index, modules)

            if (sectorName != component.sectorName) {
              sectorName = component.sectorName
              var prevComponent = components[item.index - 1]
              if (item.index != 0 && prevComponent != null && !prevComponent.fitInOnePage) {
                $printArea.append('<div class="page-break"/>')
              }

              $('<div class="sectorName"/>')
                .text(sectorName)
                .appendTo($printArea)
            }

            var $component = $('<div class="component"/>').appendTo($printArea),
              $row = $('<div class="row" />').appendTo($component),
              $col = $('<div class="col-md-12"/>').appendTo($row),
              halfContainers = $printArea.find('.col-md-6').length

            $('<div class="componentTitle">' + component.titleLabel + '</div>').appendTo($col)

            if (component.fitInOnePage && !isChart(component)) {
              $row.css('min-height', '450px')
            }

            if (
              setSideBySide &&
              ((shouldSetSideBySide(item.index - 1, modules) && halfContainers % 2 != 0) ||
                (shouldSetSideBySide(item.index + 1, modules) && halfContainers % 2 == 0))
            ) {
              $row.removeClass('row').addClass('chartRow')
              $col.removeClass('col-md-12').addClass('col-md-6')
            }

            if (component.subTitleLabel) {
              $('<div class="componentSubTitle">' + component.subTitleLabel + '</div>').appendTo(
                $col,
              )
            }

            var $container = $('<div class="component-container"></div>').appendTo($col)

            if (component.note) {
              $('<div class="componentNote">' + component.note + '</div>').appendTo($col)
            }
            module.default
              .render($container, {
                asOfDate: asOfDate,
                sectorId: component.sectorId,
                nbMonths: component.nbMonths,
                ccyPairId: component.ccyPairId || 0,
                quarterView: component.quarterly || false,
                dataInstruments: component.chartData.dataInstrumentIds,
                ccyPairIds: component.chartData.ccyPairIds,
                marketId: component.chartData.marketId,
                clientId,
              })
              .then(function() {
                emitEvent({
                  name: 'rendering',
                  message: `Rendering: ${component.component}`,
                  progress: Math.floor((unorderedIndex++ / modules.length) * 100),
                })

                resolveModule()
              })
              .catch(error => {
                reject(error)
              })
          })
        }),
      ).then(function() {
        resolve()
      })
    })
  })
}

function render($printArea, dashboardId, asOfDate, sectorId) {
  return new Promise(function(resolve, reject) {
    getDashboard(dashboardId, asOfDate, sectorId).then(function(dashboard) {
      renderComponents($printArea, asOfDate, dashboard.components, dashboard.clientId)
        .then(function() {
          var clientTemplate = processTemplate(template, {
            clientLogoUrl: `/api/config/Client/getLogo?clientId=${dashboard.clientId || 0}`,
            // url.action('GetLogo', 'Client') + '?clientId=' + (dashboard.ClientId || 0),
            masterLogoUrl: `/api/config/Client/getLogo?clientId=0`,
            dashboardTitle: dashboard.description,
            dashboardNote: dashboard.note,
            pageFooterTemplate:
              dashboard.languageId == 1
                ? 'Page #:pageNum# of #:totalPages#'
                : 'Page #:pageNum# de #:totalPages#',
          })

          $('<div class="page-break"></div>').appendTo($printArea)
          $('<p class="disclaimer"></p>')
            .html(dashboard.disclaimer)
            .appendTo($printArea)

          // Wrap half container pairs in a row
          var odd = $('div.col-md-6:odd')
          $('div.col-md-6:even').each(function(index) {
            $(this)
              .add(odd.get(index))
              .wrapAll('<div class="row"/>')
          })

          generatePdf($printArea, clientTemplate, dashboard.dashboardName).then(() => resolve())
        })
        .catch(error => {
          reject(error)
        })
    })
  }).catch(error => {
    const message = error.errorThrown || error.status || String(error)
    emitEvent({
      name: 'error',
      message,
    })
  })
}

function processTemplate(template, variables) {
  return template.replace(/\${(\w+)}/g, function(match, name) {
    return variables[name] || name
  })
}

function generatePdf($printArea, template, dashboardName) {
  return kendo.drawing
    .drawDOM($printArea, {
      paperSize: 'A4',
      margin: {
        left: '15mm',
        right: '15mm',
        top: '25.4mm',
        bottom: '25.4mm',
      },
      forcePageBreak: '.page-break',
      keepTogether: '.component',
      landscape: true,
      repeatHeaders: true,
      template: template,
    })
    .then(function(group) {
      kendo.drawing.pdf.saveAs(group, dashboardName + '.pdf')

      emitEvent({
        name: 'saveComplete',
      })
    })
}

function loadIframe(dashboardId, asOfDate, sectorId, progressCallback) {
  return new Promise(function(resolve, reject) {
    if (asOfDate instanceof Date) {
      const tzOffset = asOfDate.getTimezoneOffset() * 60000
      const localISODate = new Date(asOfDate - tzOffset).toISOString().slice(0, 10)
      asOfDate = localISODate
    }
    const reportUrl = `/dashboard.html?asOfDate=${asOfDate}&dashboardId=${dashboardId}&sectorId=${sectorId}`
    let iframe = $('#pdfExportIframe')
    if (iframe.length == 0) {
      iframe = $(
        `<iframe id="pdfExportIframe" style="position:absolute; top: -1000px; width:100%; height:500px;"></iframe>`,
      ).appendTo('body')
    }

    const receiveMessage = ({data}) => {
      if (data.name == 'error') {
        window.removeEventListener('message', receiveMessage)
        reject(data)
      } else if (data.name == 'saveComplete') {
        // cleanup
        window.removeEventListener('message', receiveMessage)
        resolve(data)
      } else {
        if (typeof progressCallback == 'function') {
          progressCallback(data)
        }
      }
    }

    window.addEventListener('message', receiveMessage)

    iframe.prop('src', reportUrl)
  })
}

export default {
  load: function($printArea, dashboardId, asOfDate, sectorId) {
    return render($printArea, dashboardId, asOfDate, sectorId)
  },
  loadIframe,
}
